'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var reservedWords = ['break', 'case', 'catch', 'class', 'continue', 'debugger', 'default', 'delete', 'do', 'else', 'export', 'extends', 'finally', 'for', 'function', 'if', 'import', 'in', 'instanceof', 'new', 'return', 'super', 'switch', 'this', 'throw', 'try', 'typeof', 'var', 'void', 'while', 'with', 'yield'];

exports.default = reservedWords;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@storybook/addon-actions/dist/lib/types/function/reservedKeywords.js
 ** module id = 542
 ** module chunks = 0
 **/